<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일', value: '점검일' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]" />

    <!--    청소(미화)-->
    <table-inspect-performance-evaluation
      v-for="(item, indexRows) in form.inspectList"
      class="mt-28px"
      v-model="item.list"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="`${indexRows + 1}. ${item.title}`"
      :sub-title="item.subTitle"
      :is-header-column1="false"
      :is-header-column2="false"
      :is-note="true"
      :is-note2="true"
      :label-column-width="700"
      :total-column-length="6"
      table-header-title="항목"
      table-header-yes="적정"
      table-header-no="미흡"
      table-header-na="해당없음"
      table-header-note="개선사항"
      table-header-note2="비고"
      @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
      @update-note="
          (param1, param2) => {
            updateListNote(indexRows, param1, param2);
          }
        "
    />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    SignField,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        field_name: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        inspectList: [
          {
            title: "유해위험요인 확인 및 개선(위험성평가)",
            list: [
              {
                id: 1,
                label: "<b>·내부 절차에 따른 실시</b><br/>" +
                  "&nbsp;&nbsp;- 위험성평가 방법<br/>" +
                  "&nbsp;&nbsp;- 위험성평가 참여자<br/>" +
                  "&nbsp;&nbsp;- 위험성평가 실시 결과 공지<br/>" +
                  "&nbsp;&nbsp;- 기타",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
              {
                id: 2,
                label: "<b>·실시 시기 및 대상의 적정성</b><br/>" +
                  "&nbsp;&nbsp;- 정기평가: 매년(계획에 따른 시기), 전체 작업 대상<br/>" +
                  "&nbsp;&nbsp;- 수시평가: 아래 계획 실행 전<br/><br/>" +
                  "<수시평가 대상><br/>" +
                  "&nbsp;&nbsp;1. 사업장 건설물의 설치･이전･변경 또는 해체<br/>" +
                  "&nbsp;&nbsp;2. 기계･기구, 설비, 원재료 등의 신규 도입 또는 변경<br/>" +
                  "&nbsp;&nbsp;3. 건설물, 기계･기구, 설비 등의 정비 또는 보수<br/>" +
                  "&nbsp;&nbsp;4. 작업방법 또는 작업절차의 신규 도입 또는 변경<br/>" +
                  "&nbsp;&nbsp;5. 중대산업사고 또는 산업재해(휴업 이상의 요양을 요하는 경우에 한정한다) 발생<br/>" +
                  "&nbsp;&nbsp;6. 그 밖에 본부 전담조직에서 필요하다고 판단한 경우",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
              {
                id: 3,
                label: "<b>·실시 방법의 적정성</b><br/>" +
                  "&nbsp;&nbsp;- 안전보건관리책임자의 실시 총괄·관리<br/>" +
                  "&nbsp;&nbsp;- 안전관리자, 보건관리자의 지도·조언·보좌<br/>" +
                  "&nbsp;&nbsp;- 관리감독자의 유해·위험요인 파악<br/>" +
                  "&nbsp;&nbsp;- 위험성평가 실시를 위한 교육 등",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
              {
                id: 4,
                label: "<b>·유해·위험요인 파악의 적정성</b><br/>" +
                  "&nbsp;&nbsp;- 현장 점검을 통해 위험성평가에 유해·위험요인 파악 누락이 없는지 확인",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
              {
                id: 5,
                label: "<b>·위험요인 개선 수준</b><br/>" +
                  "&nbsp;&nbsp;- 현장 점검을 통해 적정 개선여부 확인",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
            ]
          },
          {
            title: "안전보건관리책임자등 업무수행 평가",
            subTitle: "* 대상별 업무수행평가표도 별도로 작성·제출할 것",
            list: [
              {
                id: 1,
                label: "<b>·안전보건관리책임자</b><br/>" +
                  "&nbsp;&nbsp;- 산업재해 예방계획의 수립<br/>" +
                  "&nbsp;&nbsp;- 안전보건관리규정 작성 및 변경<br/>" +
                  "&nbsp;&nbsp;- 안전보건교육<br/>" +
                  "&nbsp;&nbsp;- 산업재해 예방계획의 수립 등",
                is_checked: "",
                note: "",
                note2: "총괄부서(안전총괄과)",
                title: "",
              },
              {
                id: 2,
                label: "<b>·안전보건총괄책임자(도급 등 업무 시)</b><br/>" +
                  "&nbsp;&nbsp;- 도급 등 업무의 위험성평가 실시<br/>" +
                  "&nbsp;&nbsp;- 산업재해가 발생할 급박한 위험이 있는 경우 및 중대재해 발생시 작업의 중지<br/>" +
                  "&nbsp;&nbsp;- 도급시 산업재해 예방조치 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 3,
                label: "<b>·관리감독자(현업업무 부서장 또는 담당자)</b><br/>" +
                  "&nbsp;&nbsp;- 지휘·감독하는 작업과 관련된 기계·기구 또는 설비의 안전·보건 점검 및 이상유무 확인<br/>" +
                  "&nbsp;&nbsp;- 소속된 근로자의 작업복·보호구 및 방호장치 점검<br/>" +
                  "&nbsp;&nbsp;- 작업장 정리·정돈 등",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "",
              },
            ]
          },
          {
            title: "종사자 참여 활성화",
            list: [
              {
                id: 1,
                label: "<b>·산업안전보건위원회를 통한 종사자 의견 청취</b>",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "",
              },
              {
                id: 2,
                label: "<b>·안전보건협의체(도급부서) 운영을 통한 종사자 참여 및 의견 청취</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 3,
                label: "<b>·직원 의견 제안 창구(새올 중대재해예방 게시판 등) 이용</b>",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "",
              },
            ]
          },
          {
            title: "중대산업재해 발생 대비 매뉴얼 마련 및 조치",
            list: [
              {
                id: 1,
                label: "<b>·재해 유형별 ‘중대산업재해 대비 매뉴얼’ 마련</b>",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "",
              },
              {
                id: 2,
                label: "<b>·매뉴얼 내 조직, 구성, 역할 등의 파악·숙지</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 3,
                label: "<b>·재해 발생 시 유관기관(소방서, 경찰서 등) 보고 조치</b>",
                is_checked: "",
                note: "",
                note2: "중대재해 발생부서",
                title: "",
              },
              {
                id: 4,
                label: "<b>·재해 발생 시 재발방지를 위한 조치 (원인 및 대책수립, 사고조사 등)</b>",
                is_checked: "",
                note: "",
                note2: "중대재해 발생부서",
                title: "",
              },
            ]
          },
          {
            title: "도급·용역·위탁 시 안전보건관리",
            subTitle: "* ‘도급·용역·위탁 시 안전보건 확보 체크리스트’ 증빙자료로 제출",
            list: [
              {
                id: 1,
                label: "<b>·수행한 도급·용역·위탁 업무 기록·관리</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 2,
                label: "<b>·도급·용역·위탁 계약 단계에서 적격 수급인 선정, 적정기간 준수</b><br/>" +
                  "&nbsp;&nbsp;- * 수급업체 ‘안전보건수준평가표’ 증빙자료로 제출",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 3,
                label: "<b>·도급·용역·위탁 수행 단계에서 안전보건활동</b><br/>" +
                  "&nbsp;&nbsp;- 사전에 유해·위험물질의 유해성·위험성, 유해·위험작업에 대한 주의사항 등 안전보건에 관한 정보 제공<br/>" +
                  "&nbsp;&nbsp;- 안전보건협의체 구성·운영, 순회점검<br/>" +
                  "&nbsp;&nbsp;- 적정기간 보장 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
              {
                id: 4,
                label: "<b>·도급·용역·위탁 완료 후 안전보건수준 평가(평가결과 환류)</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "",
              },
            ]
          },
          {
            title: "근로자 안전보건 교육 실시",
            list: [
              {
                id: 1,
                label: "<b>·정기교육</b><br/>" +
                  "&nbsp;&nbsp;- 현업근로자 : 반기 12시간 이상<br/>" +
                  "&nbsp;&nbsp;- 관리감독자 : 연간 16시간 이상",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
              {
                id: 2,
                label: "<b>·채용 시 교육</b><br/>" +
                  "&nbsp;&nbsp;- 일용근로자 및 1주일 이하 기간제 근로자 : 1시간 이상<br/>" +
                  "&nbsp;&nbsp;- 1주일 초과 1개월 이하 기간제 근로자 : 4시간 이상<br/>" +
                  "&nbsp;&nbsp;- 그 밖의 근로자 : 8시간 이상",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
              {
                id: 3,
                label: "<b>·작업내용 변경 시 교육</b><br/>" +
                  "&nbsp;&nbsp;- 일용근로자 및 1주일 이하 기간제 근로자 : 1시간 이상<br/>" +
                  "&nbsp;&nbsp;- 그 밖의 근로자 : 2시간 이상",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
              {
                id: 4,
                label: "<b>·특별교육(밀폐공간, 위험물질관리 등의 위험작업)</b><br/>" +
                  "&nbsp;&nbsp;- 일용근로자 및 1주일 이하 기간제 근로자 : 2시간 이상<br/>" +
                  "&nbsp;&nbsp;- 단, 타워크레인 신호수의 경우 8시간 이상<br/>" +
                  "&nbsp;&nbsp;- 그 밖의 근로자 : 16시간 이상<br/>" +
                  "&nbsp;&nbsp;- (단기간 또는 간헐적 작업의 경우에는 2시간 이상)",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
              {
                id: 5,
                label: "<b>·물질안전보건자료 교육(화학물질 취급 작업)</b>",
                is_checked: "",
                note: "",
                note2: "현업부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
              {
                id: 6,
                label: "<b>·산업안전보건법 이외의 안전･보건 관계법령에 따른 유해･위험한 작업에 관한 안전･보건에 관한 교육 실시</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "산업안전보건법에 따른 안전보건교육",
              },
            ]
          },
          {
            title: "산업안전보건법 등 안전보건관계법령 이행",
            list: [
              {
                label: "<b>·안전보건총괄(관리), 안전·보건관리자, 산업보건의 선임 및 위촉</b>",
                is_checked: "",
                note: "",
                note2: "총괄부서(안전총괄과)",
                title: "안전보건 관리체제",
              },
              {
                label: "<b>·관리감독자 안전보건 업무 부여 등</b>",
                is_checked: "",
                note: "",
                note2: "총괄부서(안전총괄과)",
                title: "안전보건 관리체제",
              },
              {
                label: "<b>·산업안전보건위원회 구성 및 운영</b>",
                is_checked: "",
                note: "",
                note2: "총괄부서(안전총괄과)",
                title: "안전보건 관리체제",
              },
              {
                label: "<b>·안전보건관리규정 제정 및 변경</b>",
                is_checked: "",
                note: "",
                note2: "총괄부서(안전총괄과)",
                title: "안전보건 관리체제",
              },

              {
                label: "<b>·산업재해조사표 제출 여부 (산재발생일로부터 한 달 이내 제출)</b>",
                is_checked: "",
                note: "",
                note2: "산재발생 부서",
                title: "산업재해발생 보고 및 기록관리, 법령 고지 등",
              },
              {
                label: "<b>·법령 요지 및 안전보건관리규정 게시</b>",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "산업재해발생 보고 및 기록관리, 법령 고지 등",
              },
              {
                label: "<b>·안전보건표지 설치 및 부착</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "산업재해발생 보고 및 기록관리, 법령 고지 등",
              },

              {
                label: "<b>·도급인 및 수급인 안전보건협의체 구성 및 운영(매월 1회 이상 정기적 개최)</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },
              {
                label: "<b>·도급 작업장 순회점검(1회/주)</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },
              {
                label: "<b>·작업장 합동 안전·보건점검(1회/분기)</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },
              {
                label: "<b>·안전보건교육 지원 및 실시 확인</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },
              {
                label: "<b>·발파작업, 화재·폭발, 붕괴·지진 대비 경보체계 운영 및 대피방법 등 훈련</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },
              {
                label: "<b>·수급업체 위생시설 설치 또는 이용 협조</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "도급에 따른 산재예방조치",
              },

              {
                label: "<b>·건설공사 발주자의 산업재해 예방 조치 (기본 안전보건대장 수립 및 이행 확인)</b><br/>" +
                  "&nbsp;&nbsp;* 총 공사금액 50억원 이상",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "건설업 등 산업재해예방",
              },
              {
                label: "<b>·안전보건조정자 선임</b><br/>" +
                  "&nbsp;&nbsp;* 2개 이상의 건설공사(같은 장소)를 도급한 발주자 (총 공사금액 50억원 이상)",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "건설업 등 산업재해예방",
              },

              {
                label: "<b>·안전인증대상 기계 등 사용 시 안전인증 취득 여부</b><br/>" +
                  "&nbsp;&nbsp;* 크레인, 고소작업대, 압력용기, 보호구(안전화, 안전모 등) 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "유해·위험 기계 등에 대한 방호조치",
              },
              {
                label: "<b>·유해위험기계 등 안전검사 실시</b><br/>" +
                  "&nbsp;&nbsp;* 크레인, 압력용기 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "유해·위험 기계 등에 대한 방호조치",
              },

              {
                label: "<b>·물질안전보건자료 게시･경고표지 부착･교육 실시</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "유해·위험 물질에 대한 조치",
              },
              {
                label: "<b>·석면함유 물질 자재에 대한 석면조사</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "유해·위험 물질에 대한 조치",
              },
              {
                label: "<b>·석면함유 물질 자재 해체제거작업 준수(석면해체제거업자 도급 여부)</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "유해·위험 물질에 대한 조치",
              },

              {
                label: "<b>·일반건강진단</b>",
                is_checked: "",
                note: "",
                note2: "전 부서",
                title: "근로자 보건관리",
              },
              {
                label: "<b>·특수건강진단</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "근로자 보건관리",
              },

              {
                label: "<b>·작업장 및 통로 전도방지 조치 여부</b><br/>" +
                  "&nbsp;&nbsp;* 미끄럼방지 조치(논슬림테이프 부착) 설치, 바닥 청결, 조도확보 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·안전한 사다리 통로 확보</b><br/>" +
                  "&nbsp;&nbsp;* 견고한 구조, 전도방지 조치, 사다리의 상단은 걸쳐놓은 지점으로부터 60cm이상 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·추락위험장소 안전난간 및 덮개 등 설치 여부</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·높은 곳 작업 시 작업발판 설치 여부</b><br/>" +
                  "&nbsp;&nbsp;* 비계 설치 후 작업발판 조립, 이동식비계, 말비계 사용",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·승강기 보수 작업 등</b><br/>" +
                  "&nbsp;&nbsp;* 방호장치(출입문 인터록 장치 등) 정상 작동, 작업 시 전원 차단 후 잠금장치/표지판 부착 후 작업",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·밀폐공간 위험작업 보건관리</b><br/>" +
                  "&nbsp;&nbsp;* 작업프로그램 수립, 작업허가서, 출입금지 표지판, 농도측정, 환기, 송기마스크 등 개인보호구 착용, 감시인 배치 등",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·외벽 청소업무</b><br/>" +
                  "&nbsp;&nbsp;* 작업전 로프, 고리, 달비계 등 체결상태 확인, 로프 외 구명줄 설치 후 안전대 체결, 로프 및 구명줄",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·추락 등 위험작업 근로장에게 안전모, 안전대 등 보호구 지급 및 착용 여부</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·위험기계 등의 전동기 회전체 등에 덮개 설치 여부</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·전동기 콘센트 등 접지 연결 여부</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },
              {
                label: "<b>·기타 안전·보건 관련 사항</b>",
                is_checked: "",
                note: "",
                note2: "해당부서",
                title: "안전보건기준",
              },

              {
                noLabel: true,
                label: "",
                is_checked: "",
                note: "",
                note2: "",
                title: "·추가해야할 법령 및 의무사항이 있을 경우 포함하여 작성",
              },
            ]
          },
        ],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexList, indexRows, text) {
      this.form.inspectList[indexList].list[indexRows].is_checked = text;
    },
    updateListNote(indexList, indexRows, text) {
      this.form.inspectList[indexList].list[indexRows].note = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
